function ltSyncVariantPrice(select) {
  var container = select.closest('.product-variant-dropdown');
  if (!container) return;
  var priceScript = container.querySelector('.lt-variant-prices');
  var button = container.querySelector('.product-variant-submit-button');
  if (!priceScript || !button) return;
  try {
    var prices = JSON.parse(priceScript.textContent);
    var price = prices[select.value];
    if (price) {
      button.value = 'AJOUTER · ' + price;
    }
  } catch (err) {}
}

function ltSyncAllVariantPrices() {
  document.querySelectorAll('.product-variant-select').forEach(ltSyncVariantPrice);
}

document.addEventListener('change', function (e) {
  if (e.target.matches('.product-variant-select')) {
    ltSyncVariantPrice(e.target);
  }
});

ltSyncAllVariantPrices();

new MutationObserver(ltSyncAllVariantPrices).observe(document.body, { childList: true, subtree: true });

function ltUpdateVariantPrice(select) {
  var form = select.closest('form');
  if (!form) return;

  var button = form.querySelector('.product-variant-submit-button');
  if (!button) return;

  var option = select.options[select.selectedIndex];
  var price = option.getAttribute('data-price');

  if (price) {
    button.textContent = 'AJOUTER · ' + price;
  }
}

document.addEventListener('click', function (e) {
  if (e.target.matches('.product-variant-submit-button')) {
    var btn = e.target;
    btn.classList.remove('lt-pulse');
    void btn.offsetWidth;
    btn.classList.add('lt-pulse');
  }
}, true);